import {PktButton} from "@oslokommune/punkt-react";
import {longDate} from "../../../utils/datoUtil";
import React from "react";
import {goToUrl} from "../../../utils/utils";
import {PLASS_SOKNAD_BASE} from "../../../routes";
import ApplicationCard from "../../ApplicationCard/ApplicationCard";

type Props = {
    barnNavn: string;
    søknadsfrist: Date;
}

const SøknadsfristCard = ({barnNavn, søknadsfrist}: Props) => {
    const idag = new Date()

    if (søknadsfrist < idag) {
        return (
            <ApplicationCard title={barnNavn} variant={"blå"}>
                <div
                    className={"pkt-txt-16-light"}>Du kan søke om barnehageplass for {barnNavn}.
                </div>
                <SøkBarnehagePlassButton/>
            </ApplicationCard>
        )
    } else {
        return (
            <ApplicationCard title={barnNavn} variant={"blå"}>
                <div
                    className={"pkt-txt-16-light"}>Nå kan du søke om barnehageplass for {barnNavn}. Søknadsfristen
                    er {longDate(søknadsfrist.toDateString())}.
                </div>
                <SøkBarnehagePlassButton/>
            </ApplicationCard>
        )
    }
}

function SøkBarnehagePlassButton() {
    return (
        <PktButton onClick={() => goToUrl(PLASS_SOKNAD_BASE)} size={"small"}
                   className={"mt-size-16"}>
            Søk barnehageplass
        </PktButton>
    )
}

export default SøknadsfristCard